import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { resolveContent } from '@nu-art/ts-common';
import './Dialog_Confirmation.scss';
export class Dialog_Confirmation extends ComponentSync {
    static show = (data) => {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_Confirmation, { ...data }) });
    };
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        const className = _className('quai-manager-ui__confirmation-dialog', this.props.className);
        return _jsxs(LL_V_L, { className: className, id: this.props.id, children: [this.renderHeader(), this.renderContent(), this.renderButtons()] });
    }
    renderHeader = () => {
        if (!this.props.header)
            return;
        return _jsx(LL_H_C, { className: 'quai-manager-ui__confirmation-dialog__header', children: resolveContent(this.props.header) });
    };
    renderContent = () => {
        if (!this.props.content)
            return;
        return _jsx(LL_V_L, { className: 'quai-manager-ui__confirmation-dialog__content', children: resolveContent(this.props.content) });
    };
    renderButtons = () => {
        if (!this.props.buttons?.length)
            return;
        return _jsx(LL_H_C, { className: 'quai-manager-ui__confirmation-dialog__buttons', children: this.props.buttons.map((button, i) => {
                return _jsx(Button, { variant: button.isPreferred ? 'primary' : 'secondary', onClick: async () => {
                        await button.action();
                        ModuleFE_Dialog.close();
                    }, children: button.label }, i);
            }) });
    };
}
//# sourceMappingURL=Dialog_Confirmation.js.map